import React from "react";
import {
  CustomRadio,
  HiddenRadio,
  RadioContainer,
  RadioDot,
  RadioLabel,
  RadioOptionContainer,
  RadioTitle,
} from "./radioButton.styled";

interface RadioButtonProps {
  title?: string;
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  name: string;
  disabled?: boolean;
  required?: boolean;
}

export const RadioButton: React.FC<RadioButtonProps> = (props) => {
  return (
    <RadioContainer>
      {props.title && (
        <RadioTitle required={props.required}>{props.title}</RadioTitle>
      )}

      <RadioOptionContainer>
        <HiddenRadio
          type="radio"
          id={`${props.name}-${props.value}`}
          name={props.name}
          value={props.value}
          checked={props.checked}
          onChange={() => props.onChange(props.value)}
          disabled={props.disabled}
        />

        <CustomRadio
          htmlFor={`${props.name}-${props.value}`}
          disabled={props.disabled}
          checked={props.checked}
        >
          <RadioDot checked={props.checked} />
        </CustomRadio>

        <RadioLabel
          htmlFor={`${props.name}-${props.value}`}
          disabled={props.disabled}
        >
          {props.label}
        </RadioLabel>
      </RadioOptionContainer>
    </RadioContainer>
  );
};
